module.exports = __webpack_public_path__ + "img/ky.5908392a.svg";